exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".wd-modal-container{display:flex;flex-direction:column;padding:16px;max-height:100%;overflow:hidden}.wd-modal-header{font-size:16px;text-align:center;color:#1ea2e8;text-transform:uppercase}.wd-scroll-table{max-height:100%;overflow:auto}.wd-item-container{padding:8px}.wd-table-item{padding:8px;text-align:center}.wd-table-header{font-weight:700}tr:nth-child(2n){background-color:#ddd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/blocks/workshopDetailsModal/styles.css
// module id = 978
// module chunks = 0